import { Stack } from '@mui/material'
import { Outlet } from 'react-router-dom'

import ErrorAlert from '../Shared/Alerts/ErrorAlert.jsx'
import SuccessAlert from '../Shared/Alerts/SuccessAlert.jsx'
import { useAuth } from '../Shared/Contexts/AuthContext.jsx'
import Footer from './Footer/Footer.jsx'
import NavBar from './Navbar/NavBar.jsx'

const MainLayout = () => {
  const { authState } = useAuth()

  return (
    <>
      <Stack
        direction={'column'}
        justifyContent={authState.isAuthenticated ? 'flex-start' : 'space-between'}
        minHeight={'100vh'}
        flex={1}
      >
        {authState.isAuthenticated ? <NavBar /> : null}
        <Outlet />
        {authState.isAuthenticated ? null : <Footer />}
      </Stack >
      <SuccessAlert></SuccessAlert>
      <ErrorAlert></ErrorAlert>
    </>
  )
}

export default MainLayout
